( function () {
	/* eslint no-undef:0 */
	/* eslint max-params:0 */
	'use strict';

	function ObsFileController ( $scope, $rootScope, $timeout, logger, moment, evidence, observation, level, isTemplatePreview, $modalInstance, apiService, fileService, UPLOAD_EVD_MSGS, FILETYPES ) {
		var self = this;

		self.acceptedFileFormats = '';
		self.warningMsgs         = UPLOAD_EVD_MSGS;
		self.progress            = 0;
		self.file                = null;
		self.isDuplicate         = false;
		self.maxSize             = fileService.validation().maxSize;
		self.inProgress          = false;
		self.uploadRequest       = null;

		self.evidence = {
			'id'          : apiService.generateUUID(),
			'name'        : '',
			'type'        : 3,
			'description' : '',
			'scope'       : 'public',
			'url'         : null
		};

		var passThrough = {
			'$on'   : angular.noop,
			'abort' : angular.noop
		};

		function closeView () {
			$modalInstance.close();
		}

		function makeDefault ( isDup ) {
			self.isDuplicate = Boolean( isDup );
			self.progress    = 0;
		}

		function isImageFile ( mimeType ) {
			var extRegex = [ /jpeg/, /jpg/, /png/, /gif/ ];

			return extRegex.some( function ( item ) {
				return item.test( mimeType );
			} );
		}

		function isDuplicate ( fileId ) {
			if ( observation.masterEvidences ) {
				return observation.masterEvidences.some( function ( evd ) {
					return evd.url === fileId;
				} );
			}

			return false;
		}

		function attachFileEvidence ( fileData ) {
			if ( isImageFile( fileData.mimeType ) ) {
				self.evidence.type = 5;
			}

			self.evidence.url         = fileData.id;
			self.evidence.description = self.file.name;

			if ( !level.evidences ) {
				level.evidences = [ ];
			}

			level.evidences.push( angular.copy( self.evidence ) );

			if ( !observation.masterEvidences ) {
				observation.masterEvidences = [ ];
			}

			observation.masterEvidences.push( angular.copy( self.evidence ) );
		}

		function uploadEvidence ( file ) {
			var fileInput = {
				'file'          : file,
				'private'       : true,
				'observationId' : observation.id,
				'type'          : FILETYPES.observation
			};

			fileService.uploading.setFlag( true );

			self.uploadRequest = fileService.upload( fileInput );

			self.uploadRequest
			.then( function ( res ) {
				var fileData = res.data;

				if ( isDuplicate( fileData.id ) ) {
					makeDefault( true );
					logger.notifyError( self.warningMsgs.duplicate );
				} else {
					attachFileEvidence( fileData );
					makeDefault();
					self.closeView();
					logger.notifySuccess( self.warningMsgs.successUpload );
				}
			}, function () {
				makeDefault();
			}, function ( evt ) {
				self.progress = Math.min( 100, parseInt( 100.0 * evt.loaded / evt.total ) );

				// broadcast the progress to be listened by EditObservation ctrl
				$rootScope.$broadcast( 'file:uploading', self.progress );
			} )
			.finally( function () {
				self.file    = null;
				fileService.uploading.setFlag( false );
				$rootScope.$broadcast( 'file:uploading', self.progress );
			} );
		}

		function fakeUploadEvidence ( file ) {
			// use fake data
			var fakeFileData = {
				'id'       : apiService.generateUUID(),
				'mimeType' : 'unknown'
			};

			var isSameFile = false;

			// compare only filename since we're not saving actual file here
			if ( observation.masterEvidences ) {
				isSameFile = observation.masterEvidences.some( function ( evd ) {
					return evd.description === file.name;
				} );
			}

			if ( isSameFile ) {
				self.isDuplicate = true;
				self.file        = null;
			} else {
				attachFileEvidence( fakeFileData );
				self.closeView();
			}
		}

		function saveEvidence ( file ) {
			// if just previewing template, do fake upload
			//  We're not going to save file in our file storage since this is just a dummy observation
			if ( isTemplatePreview ) {
				fakeUploadEvidence( file );
			} else {
				uploadEvidence( file );
			}
		}

		function cancelChanges () {
			if ( $rootScope.uploadRequest ) {
				fileService.uploading.setFlag( false );
				$rootScope.uploadRequest.abort();
			}

			$modalInstance.dismiss();
		}

		function getFileFormats () {
			fileService.initialize()
			.finally( function () {
				self.acceptedFileFormats = fileService.validation().fileFormats;
			} );
		}

		function abortRequest () {
			( $rootScope.uploadScope || passThrough ).$on( '$destroy', function () {
				( self.uploadRequest || passThrough ).abort();
			} );
		}

		function activate () {
			logger.info( 'Activated Evidence file upload' );

			getFileFormats();
			abortRequest();
		}

		self.saveEvidence  = saveEvidence;
		self.closeView     = closeView;
		self.cancelChanges = cancelChanges;
		self.makeDefault   = makeDefault;
		self.inProgress    = fileService.uploading.getFlag();

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'ObsFileController', ObsFileController );

	ObsFileController.$inject = [ '$scope', '$rootScope', '$timeout', 'logger', 'moment', 'evidence', 'observation', 'level', 'isTemplatePreview', '$modalInstance', 'apiService', 'fileService', 'UPLOAD_EVD_MSGS', 'FILETYPES' ];
} )( );
